import type { Command } from 'common/Prose/Commands'
import { INDENT_DIRECTION } from 'common/Prose/Commands/constants'
import { changeIndentation } from 'common/Prose/Commands/changeIndentation'
import { schema } from 'prose-core'

/**
 * Unindent (only really makes sense by pressing backspace or enter) with the selection being on the first position of the node.
 */
export const unindentFromStart =
  (mustBeEmpty = false): Command =>
  (state, dispatch) => {
    if (!state.selection.empty) return false
    if (state.selection.from !== state.selection.$from.start()) return false
    if (mustBeEmpty && state.selection.$from.node().childCount) return false
    const parentNode = state.selection.$from.node(-1)
    if (
      state.selection.$from.node().childCount > 0 && // kludge: backspace on an indented but empty LI should unindent it
      parentNode.type === schema.nodes.list_item &&
      state.selection.$from.index(-2) > 0 && // only skip unindenting if there are other list items before this one (so we can merge into the one above instead)
      state.selection.from !== state.selection.$from.start(-1)
    )
      return false

    /**
     * if we are in an empty toggle_list body and and the user presses backspace, don't attempt to unindent.
     */
    if (
      !mustBeEmpty &&
      parentNode.type === schema.nodes.toggle_list &&
      parentNode.firstChild &&
      parentNode.nodeSize - parentNode.firstChild.nodeSize <= 4
    ) {
      return false
    }

    /**
     * if we are in a toggle_list body, don't unindent (thus exiting the toggle_list) unless we are at the last (empty) line of the body
     */
    if (parentNode.type === schema.nodes.toggle_list && state.selection.$from.index(-1) < parentNode.childCount - 1) {
      return false
    }

    /**
     * if we are in a list item inside a toggle_list body, don't unindent (thus exiting the toggle_list)
     */
    if (
      state.selection.$from.depth >= 3 &&
      state.selection.$from.node(-3).type === schema.nodes.toggle_list &&
      state.selection.$from.node(-1).type === schema.nodes.list_item &&
      state.selection.$from.node(-1).attrs.depth === 0
    ) {
      return false
    }

    return changeIndentation(INDENT_DIRECTION.UNINDENT)(state, dispatch)
  }
